import { FeedItemModal } from "./FeedItemModal";

export default FeedItemModal;
